import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LINK_ITEMS } from 'src/constants/shared.constant';

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss']
})
export class NavComponent {
  close = false;
  link_items = LINK_ITEMS;
  router = inject(Router);

  route(value) {
    this.router.navigate([value]);
    if (this.close) {
      document.getElementById('nav_link').classList.remove('toggle_nav');
      document.getElementById('menu_icon').classList.remove('icon_position');
      this.close = false;
    }
  }

  toggleNavbar() {
    document.getElementById('nav_link').classList.toggle('toggle_nav');
    document.getElementById('menu_icon').classList.toggle('icon_position');
    document.getElementById('nav_link').classList.contains('toggle_nav') ? this.close = true : this.close = false;
  }

}
